import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Berlin() {
  return (
    <LocationPageTemplate
      page={{
        location: "Berlin",
        locationSlug: "berlin",
        keyword: "Haushaltsauflösung Berlin",
        metaTitle:
          "Haushaltsauflösung Berlin | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in ganz Berlin. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung anfragen!",
        heroSub:
          "Wir befreien Sie von Altlasten in der Hauptstadt – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909767c08665aa86d39549.jpg",
        localIntro: (
          <>
            <p>
              Berlin ist vielfältig und stellt bei Entrümpelungen oft besondere
              Anforderungen. Von den engen Treppenhäusern in Kreuzberger
              Altbauten über die Parkplatznot in Mitte bis hin zu den
              weitläufigeren Grundstücken in den Außenbezirken – wir kennen die
              Stadt und ihre Herausforderungen genau.
            </p>
            <p>
              Als Berliner Familienbetrieb sind wir täglich in allen Kiezen
              unterwegs. Wir wissen, wie wir Halteverbotszonen effektiv
              beantragen und wie wir auch aus dem fünften Stock ohne Aufzug
              sicher und zügig räumen. Unser Team ist bestens auf die typischen
              Berliner Verhältnisse vorbereitet.
            </p>
            <p>
              Egal ob es sich um eine kleine Wohnung im Wedding oder ein großes
              Haus in Zehlendorf handelt, wir bringen die nötige Erfahrung und
              das passende Equipment mit, um jede Haushaltsauflösung reibungslos
              durchzuführen.
            </p>
          </>
        ),
        trustText:
          "Ob in einer Altbauwohnung am Helmholtzplatz oder einem Reihenhaus am Stadtrand – wir verstehen die emotionale Belastung einer Wohnungsauflösung und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Herr Ozegovic hat unsere Wohnung in Berlin Mitte unglaublich schnell und professionell geräumt. Absolut empfehlenswert!",
        challengesText: (
          <>
            <p>
              Die größte Herausforderung in Berlin ist oft die Logistik.
              Fehlende Parkplätze und enge Treppenhäuser können eine
              Entrümpelung erschweren. Wir kümmern uns im Vorfeld um alle
              notwendigen Genehmigungen, wie zum Beispiel die Einrichtung einer
              Halteverbotszone direkt vor Ihrer Tür.
            </p>
            <p>
              Auch bei denkmalgeschützten Gebäuden oder empfindlichen Böden in
              Altbauten gehen wir mit größter Vorsicht vor, um Schäden zu
              vermeiden. Diskretion ist für uns selbstverständlich, besonders in
              dicht besiedelten Nachbarschaften.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Sehr zuverlässig und schnell. Die Wohnung in Charlottenburg wurde besenrein übergeben.",
            author: "Kunde aus Charlottenburg",
          },
          {
            text: "Super Service! Der Festpreis wurde eingehalten, keine bösen Überraschungen.",
            author: "Kundin aus Pankow",
          },
          {
            text: "Einfühlsam und professionell nach dem Todesfall unseres Vaters. Danke an das gesamte Team.",
            author: "Familie aus Neukölln",
          },
        ],
        neighbors: [
          { name: "Pankow", slug: "pankow" },
          { name: "Charlottenburg", slug: "charlottenburg" },
          { name: "Neukölln", slug: "neukoelln" },
          { name: "Spandau", slug: "spandau" },
        ],
        faqs: [
          {
            q: "Wie schnell kommen Sie nach Berlin?",
            a: "Wir sind täglich in Berlin unterwegs. Besichtigungstermine sind meist innerhalb von 24 Stunden möglich.",
          },
          {
            q: "Kümmern Sie sich um die Halteverbotszone?",
            a: "Ja, wir beantragen die Halteverbotszone rechtzeitig beim zuständigen Bezirksamt und stellen die Schilder auf.",
          },
          {
            q: "Entsorgen Sie auch Sondermüll?",
            a: "Ja, wir trennen den Müll fachgerecht und entsorgen auch Farben, Lacke oder alte Elektrogeräte auf den Berliner Recyclinghöfen.",
          },
          {
            q: "Muss ich bei der Räumung anwesend sein?",
            a: "Nein, nach einer kurzen Vorbesprechung und Schlüsselübergabe können Sie uns die Arbeit komplett überlassen.",
          },
        ],
      }}
    />
  );
}
